import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import { axiosOpen } from "../../api/axios";
import { getUserID } from "../../service";
import Loader from '../../component/Loader/Loader';

const PromptList = () => {
  const userID = getUserID();
  const [pageLoader, setPageLoader] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [userList, setUserList] = useState(null);
  const [promptDes, setPromptDes] = useState(null);
  const [promptRes, setPromptRes] = useState(null);
  const [openPopup, setOpenPopup] = useState (false);
 
  const convertDateFormat = (dateinput) => {
    // Split the input date into its year, month, and day components
    const [year, month, day] = dateinput.split("-");

    // Create a new Date object with the input year, month, and day components
    const dateObj = new Date(year, month - 1, day);

    // Format the output date as dd/mm/yyyy
    const formattedDate = `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;

    // Update the output date state with the formatted date
    return formattedDate;
  }

  const fetchUserDetails = async () => {
    const response = await axiosOpen.get(
      `/api/prompt/userprompts/${userID}`
    );
    setUserList(response?.data?.prompts);
    setDataLoader(false);
  };

  const getSinglePrompt = (promptDes, promptRes) => {
    setPromptDes(promptDes);
    setPromptRes(promptRes);
    setOpenPopup(true);
  };
  useEffect(() => {
    fetchUserDetails();
  }, []);

  return (
    <>
    {pageLoader ? (
      <Loader />
    ) : (
      <Container className="flex-grow-1">
        <div className="d-flex align-items-center justify-content-between">
          <div className="col-8">
            <h2 className="py-3">Saved Queries</h2>
          </div>
        </div>
        {userList?.length > 0 && (
          <div className="user-table">
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>Query</th>
                  <th>Response</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {dataLoader ? (<Loader/>
                ) : (
                  userList.map((item, index) => (
                    <tr key={index}>
                      <td>{item.description.length > 15 ? item.description.slice(0, 14) + "..." :item.description}</td>
                      <td>{item.promptresponse.length > 20 ? item.promptresponse.slice(0, 17) + "..." : item.promptresponse}</td>
                      <td>{item.promptdate.length > 9 ? convertDateFormat(item.promptdate.slice(0, 10) ) : convertDateFormat(item.promptdate)}</td>
                      <td>
                        
                        <button onClick={() => getSinglePrompt(item.description, item.promptresponse)} className="btn btn-primary">View</button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        )}

        <Modal show={openPopup}>
          <Modal.Header>
              <Modal.Title>Query: {promptDes}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p><b>Response: </b></p>
            {promptRes && 
              promptRes.split("\n").map((data, index) => {
                if(data){
                  return (
                    <span key={index}>{data}<br/></span>
                  )
                }
            })}
          </Modal.Body>
          <Modal.Footer>
              <Button variant="secondary" onClick={() => setOpenPopup(false)}>
                  Close
              </Button>
          </Modal.Footer>
        </Modal>
        
      </Container>
    )}
  </>
 
  );
};

export default PromptList;
